import { LineItemGroup } from '@/types/commercetools';

export const getBasketItemPrices = (lineItemGroup: LineItemGroup) => {
  const groupPrice = lineItemGroup.groupTotalCentAmount;
  const singlePrice = groupPrice / lineItemGroup.groupQuantity;
  const groupDiscount = lineItemGroup.priceBreakdown.totalDiscount;
  const singleDiscount = groupDiscount / lineItemGroup.groupQuantity;

  return { groupPrice, singlePrice, groupDiscount, singleDiscount };
};
